import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: change this to use aggregated data fetching
import { useCountries } from '@applyboard/business-ui-legacy';
import { Button, Flex, Grid, Text, Tooltip } from '@applyboard/crystal-ui';
import { CheckMarkOutlineIcon, WarningFillIcon } from '@applyboard/ui-icons';
import { SidebarRow } from "../SidebarRow";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export var BackgroundSection = function BackgroundSection(props) {
  return _jsx(SidebarRow, {
    title: "Background",
    content: _jsx(BackgroundRow, {
      address: props.address,
      info: props.info,
      showResidenceWarning: props.showResidenceWarning
    }),
    expandedContent: _jsx(BackgroundExpandableContent, {
      address: props.address
    }),
    expandAll: props.expandAll
  });
};
var BackgroundRow = function BackgroundRow(props) {
  var _useCountries = useCountries(),
    countryToCodeMapping = _useCountries.countryToCodeMapping,
    isLoadingCountries = _useCountries.isLoadingCountries;
  if (isLoadingCountries) {
    return null;
  }
  var countryOfCitizenship = props.info.countryOfCitizenship && (countryToCodeMapping === null || countryToCodeMapping === void 0 ? void 0 : countryToCodeMapping[props.info.countryOfCitizenship]);
  var countryOfResidence = props.address.country && (countryToCodeMapping === null || countryToCodeMapping === void 0 ? void 0 : countryToCodeMapping[props.address.country]);
  var countryOfCitizenshipVerified = !!props.info.countryOfCitizenshipVerifiedAt;
  return _jsxs(Flex, {
    direction: "column",
    gap: 2,
    children: [_jsxs(Flex, {
      direction: "column",
      children: [_jsx(Text, {
        variant: "bodyS",
        intent: "secondary",
        children: "Nationality"
      }), _jsxs(Flex, {
        direction: "row",
        gap: 2,
        align: "center",
        children: [_jsx(Grid, {
          mb: 2,
          mt: 2,
          children: _jsx(Grid.Item, {
            children: _jsx(Text, {
              children: countryOfCitizenship || '-'
            })
          })
        }), countryOfCitizenshipVerified && _jsx(Tooltip, {
          label: "This field has been verified by a document on this application",
          placement: "bottom",
          children: _jsx(Button, {
            "aria-label": "Nationality Verified",
            leadIcon: CheckMarkOutlineIcon,
            intent: "positive",
            size: "sm",
            variant: "transparent"
          })
        })]
      })]
    }), _jsxs(Flex, {
      direction: "column",
      children: [_jsx(Text, {
        variant: "bodyS",
        intent: "secondary",
        children: "Residence"
      }), _jsxs(Flex, {
        direction: "row",
        gap: 2,
        align: "center",
        children: [_jsx(Grid, {
          mb: 2,
          mt: 2,
          children: _jsx(Grid.Item, {
            children: _jsx(Text, {
              children: countryOfResidence || '-'
            })
          })
        }), props.showResidenceWarning && _jsx(Tooltip, {
          label: "Student has studied in North America but lives abroad.",
          placement: "bottom",
          children: _jsx(Button, {
            "aria-label": "Residence Warning",
            leadIcon: WarningFillIcon,
            intent: "warning",
            size: "sm",
            variant: "transparent"
          })
        })]
      })]
    })]
  });
};
export var BackgroundExpandableContent = function BackgroundExpandableContent(props) {
  var _useCountries2 = useCountries(),
    countryToCodeMapping = _useCountries2.countryToCodeMapping,
    isLoadingCountries = _useCountries2.isLoadingCountries;
  if (isLoadingCountries) {
    return null;
  }
  var studentAddress = [{
    name: 'Street',
    value: props.address.street
  }, {
    name: 'City/Town',
    value: props.address.city
  }, {
    name: 'Country',
    value: countryToCodeMapping === null || countryToCodeMapping === void 0 ? void 0 : countryToCodeMapping[props.address.country]
  }, {
    name: 'Province/State',
    value: props.address.province
  }, {
    name: 'Postal/Zip',
    value: props.address.postal
  }];
  return _jsx(_Fragment, {
    children: studentAddress === null || studentAddress === void 0 ? void 0 : studentAddress.map(function (_ref, idx) {
      var name = _ref.name,
        value = _ref.value;
      return _jsxs(Grid, {
        mt: 2,
        mb: 2,
        gap: 1,
        children: [_jsx(Grid.Item, {
          width: {
            xs: 5
          },
          children: _jsx(Text, {
            variant: "bodyS",
            children: name
          })
        }), _jsx(Grid.Item, {
          children: _jsx(Text, {
            variant: "bodyS",
            contrast: typeof value === 'string' && value !== '' ? 'high' : 'low',
            children: typeof value === 'string' && value !== '' ? value : 'N/A'
          })
        })]
      }, idx);
    })
  });
};